/**
 * PensumAgentesApiClient -- el pensum de cada agente, para la vista en cascada (PENSUM-PANEL-CASCADA-T1).
 *
 * Contrato PROPUESTO por P en el [COORD] de la tarea (sobre la forma de los planes de Atenea #31563): GET
 * /api/v1/learning/pensum/agentes -> data.items[] = { agente, plan: {id, version, estado}, unidadesTotal, siguiente,
 * unidades: [{ id, titulo, skill, skillVersion, dominio, prerrequisitos, criterio, evidenciaRequerida, estado,
 * intentos: [{ fecha, revisor, resultado, evidencia: [{ tipo, ref, url }] }] }] }.
 *
 * FAIL-OPEN: mientras la ruta no este publicada devuelve NO_PUBLICADO y la vista lo dice; el dia que A la sirva, se
 * enciende sola sin re-deploy del panel.
 *
 * @module infrastructure/api/PensumAgentesApiClient
 */

import { ApiBase } from './ApiBase.js';

async function leer(ruta) {
  let res;
  try {
    res = await ApiBase.get(ruta);
  } catch {
    return { ok: false, motivo: 'SIN_RED' };
  }
  if (res.ok) return { ok: true, data: res.data?.data ?? res.data ?? {} };
  const code = String(res.code ?? '');
  const txt = JSON.stringify(res.error || '');
  if (code === '404' || /not\s*found|404/i.test(txt)) return { ok: false, motivo: 'NO_PUBLICADO' };
  if (code === '401' || code === 'UNAUTHORIZED' || /401|unauthor/i.test(txt)) return { ok: false, motivo: 'SIN_SESION' };
  if (code === '403' || /403|forbidden/i.test(txt)) return { ok: false, motivo: 'PROHIBIDO' };
  return { ok: false, motivo: 'ERROR_API' };
}

export const PensumAgentesApiClient = {
  /** Nunca lanza. @returns {Promise<{ok:boolean, data?:object, motivo?:string}>} */
  async get() {
    return leer('/api/v1/learning/pensum/agentes');
  },

  /**
   * PENSUM-NEXO-PANEL-T1: el pensum comun de Nexo y el avance de cada agente (contrato de P #33255, aceptado por A
   * #33263). Mismo fail-open: sin la ruta, NO_PUBLICADO. Nunca lanza.
   */
  async getNexo() {
    return leer('/api/v1/learning/pensum/nexo');
  }
};
